import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";


function CurrentRepaymentDateAttribute({ id, title, value }) {
  return (
    <>
      <Typography
        component='label'
        htmlFor={id}
        sx={{ fontSize: 16, pt: 2, fontWeight: "bold" }}
      >
        {title}
      </Typography>
      <Box
        id={id}
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#E2E2E2",
          height: "46px",
          borderRadius: 1,
          border: "1px solid #BBBBBB",
          px: 1,
          fontWeight: "bold",
          fontSize: 16,
        }}
      >
        {value}
      </Box>
    </>
  )
};

CurrentRepaymentDateAttribute.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default CurrentRepaymentDateAttribute;